var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "ui-textbox", class: _vm.classes }, [
    _vm.icon || _vm.$slots.icon
      ? _c(
          "div",
          { staticClass: "ui-textbox-icon-wrapper" },
          [
            _vm._t("icon", function () {
              return [_c("UiIcon", { attrs: { icon: _vm.icon } })]
            }),
          ],
          2
        )
      : _vm._e(),
    _c("div", { staticClass: "ui-textbox-content" }, [
      _c("label", { staticClass: "ui-textbox-label" }, [
        _c(
          "div",
          { class: ["ui-input-content", _vm.inputContentClasses] },
          [
            !_vm.multiLine
              ? _c("input", {
                  directives: [
                    {
                      name: "autofocus",
                      rawName: "v-autofocus",
                      value: _vm.autofocus,
                      expression: "autofocus",
                    },
                  ],
                  ref: "input",
                  staticClass: "ui-textbox-input",
                  style: _vm.isActive
                    ? { borderBottomColor: _vm.$themeTokens.primaryDark }
                    : {},
                  attrs: {
                    autocapitalize: _vm.autocapitalize
                      ? _vm.autocapitalize
                      : null,
                    autocomplete: _vm.autocomplete ? _vm.autocomplete : null,
                    disabled: _vm.disabled,
                    max: _vm.maxValue,
                    maxlength: _vm.enforceMaxlength ? _vm.maxlength : null,
                    minlength: _vm.minlength,
                    min: _vm.minValue,
                    name: _vm.name,
                    number: _vm.type === "number" ? true : null,
                    placeholder: _vm.hasFloatingLabel ? null : _vm.placeholder,
                    readonly: _vm.readonly,
                    required: _vm.required,
                    step: _vm.stepValue,
                    tabindex: _vm.tabindex,
                    type: _vm.type,
                  },
                  domProps: { value: _vm.value },
                  on: {
                    blur: _vm.onBlur,
                    change: _vm.onChange,
                    focus: _vm.onFocus,
                    input: function ($event) {
                      return _vm.updateValue($event.target.value)
                    },
                    keydown: [
                      function ($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k(
                            $event.keyCode,
                            "enter",
                            13,
                            $event.key,
                            "Enter"
                          )
                        )
                          return null
                        return _vm.onKeydownEnter.apply(null, arguments)
                      },
                      _vm.onKeydown,
                    ],
                  },
                })
              : _c("textarea", {
                  directives: [
                    {
                      name: "autofocus",
                      rawName: "v-autofocus",
                      value: _vm.autofocus,
                      expression: "autofocus",
                    },
                  ],
                  ref: "textarea",
                  staticClass: "ui-textbox-textarea",
                  style: _vm.isActive
                    ? { borderBottomColor: _vm.$themeTokens.primaryDark }
                    : {},
                  attrs: {
                    autocpitalize: _vm.autocapitalize
                      ? _vm.autocapitalize
                      : null,
                    autocomplete: _vm.autocomplete ? _vm.autocomplete : null,
                    disabled: _vm.disabled,
                    maxlength: _vm.enforceMaxlength ? _vm.maxlength : null,
                    minlength: _vm.minlength,
                    name: _vm.name,
                    placeholder: _vm.hasFloatingLabel ? null : _vm.placeholder,
                    readonly: _vm.readonly,
                    required: _vm.required,
                    rows: _vm.rows,
                    tabindex: _vm.tabindex,
                  },
                  domProps: { value: _vm.value },
                  on: {
                    blur: _vm.onBlur,
                    change: _vm.onChange,
                    focus: _vm.onFocus,
                    input: function ($event) {
                      return _vm.updateValue($event.target.value)
                    },
                    keydown: [
                      function ($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k(
                            $event.keyCode,
                            "enter",
                            13,
                            $event.key,
                            "Enter"
                          )
                        )
                          return null
                        return _vm.onKeydownEnter.apply(null, arguments)
                      },
                      _vm.onKeydown,
                    ],
                  },
                }),
            _vm.showClearButton
              ? _c("KIconButton", {
                  attrs: {
                    icon: "clear",
                    color: _vm.$themeTokens.annotation,
                    size: "small",
                    ariaLabel: _vm.clearAriaLabel,
                    "data-test": "clearIcon",
                  },
                  on: { click: _vm.clearText },
                })
              : _vm._e(),
          ],
          1
        ),
        _vm.label || _vm.$slots.default
          ? _c(
              "div",
              { staticClass: "ui-textbox-label-text", class: _vm.labelClasses },
              [
                _vm._t("default", function () {
                  return [_vm._v(_vm._s(_vm.label))]
                }),
              ],
              2
            )
          : _vm._e(),
      ]),
      _c("div", { staticClass: "ui-textbox-feedback" }, [
        _vm.showError
          ? _c(
              "div",
              {
                staticClass: "ui-textbox-feedback-text",
                style: { color: _vm.$themeTokens.error },
              },
              [
                _vm._t("error", function () {
                  return [
                    _vm._v("\n          " + _vm._s(_vm.error) + "\n        "),
                  ]
                }),
              ],
              2
            )
          : _vm.showHelp
          ? _c(
              "div",
              { staticClass: "ui-textbox-feedback-text" },
              [
                _vm._t("help", function () {
                  return [
                    _vm._v("\n          " + _vm._s(_vm.help) + "\n        "),
                  ]
                }),
              ],
              2
            )
          : _c("div", { staticClass: "ui-textbox-feedback-text" }, [
              _vm._v("\n         \n      "),
            ]),
        _vm.maxlength
          ? _c("div", { staticClass: "ui-textbox-counter" }, [
              _vm._v(
                "\n        " +
                  _vm._s(_vm.valueLength + "/" + _vm.maxlength) +
                  "\n      "
              ),
            ])
          : _vm._e(),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }